const names = {
  REQUEST_DAILY_ANOMALY_REPORT: 'REQUEST_DAILY_ANOMALY_REPORT',
  RECEIVE_DAILY_ANOMALY_REPORT: 'RECEIVE_DAILY_ANOMALY_REPORT',
  FAILURE_DAILY_ANOMALY_REPORT: 'FAILURE_DAILY_ANOMALY_REPORT',
};

export default names;
